import React, { useEffect } from 'react'
import { TextField, MenuItem } from '@mui/material'
import { TypeStorage } from '../../interfaces/TypeStorage/TypeStorage'
import { useTypeStorage } from '../../hooks/useTypeStorage'

interface OrderOriginsDDLProps {
  onChange: any
  value: any
  type?: 'outlined' | 'filled' | 'standard' | undefined
  defaultLabel?: string
  isSearching?: boolean
  fullWidth?: boolean
  error?: boolean
}

export const TypeStorageDLL: React.FC<OrderOriginsDDLProps> = ({
  onChange,
  value,
  type,
  fullWidth = false,
  error = false,
  defaultLabel
}) => {
  const {
    typeStorageState: { typestorage },
    getTypeStorage
  } = useTypeStorage()

  useEffect(() => {
    if (typestorage?.length === 0) {
      getTypeStorage()
    }
  }, [])

  const arrTypeStorage =
    typestorage !== undefined
      ? typestorage.map((option: TypeStorage) => (
          <MenuItem key={option.typeStorageId} value={option.typeStorageId}>
            {option.name}
          </MenuItem>
        ))
      : []

  return (
    <TextField
      variant={type}
      id='typeStorageId'
      name='typeStorageId'
      label={defaultLabel}
      select
      value={value}
      onChange={onChange}
      fullWidth={fullWidth}
      error={error}
      helperText={
        error ? 'Debe seleccionar un tipo de almacenamiento' : undefined
      }
    >
      <MenuItem key={0} value={0}>
        {'Seleccionar Tipo de almacenamiento...'}
      </MenuItem>
      {arrTypeStorage}
    </TextField>
  )
}
